/* eslint-disable @typescript-eslint/no-explicit-any */
import { SystemUserInterfaceEnums } from "@/Enums/SystemUserInterfaceEnums";
import { LoginApplyDocument } from "@/Interfaces/LoginApplyDocument";
import { UserTokenDocument } from "@/Interfaces/UserTokenDocument";
import { apiHelper } from "@/Utils/ApiHelper";

export class AccountService {
  static async heartbeatKeep() : Promise<boolean>{
    const apiPath = '/api/user/heartbeat-keep';

    const response = await apiHelper.post<UserTokenDocument>(apiPath, {});

    // 存储令牌
    localStorage.setItem('OnlineBusinessHall.Token', response.token);
    localStorage.setItem('OnlineBusinessHall.user', JSON.stringify(response.userId).toString());

    return true;
  }

  static async applyLogin() : Promise<LoginApplyDocument> {
    const apiPath = '/api/user/applyLogin';
    let target_id = '';
    const device_id = window.localStorage.getItem('OnlineBusinessHall.deviceId') as string;
    if (device_id) target_id = device_id;
    
    const url = target_id?`${apiPath}?target_id=${target_id}`:apiPath;
    const response = await apiHelper.get<LoginApplyDocument>(url);
    window.localStorage.setItem('OnlineBusinessHall.deviceId', response._id.toString());
    return response;
  }

  static async loginWithPassword(username:string, password:string, apply_id:string, verify_code:string) : Promise<boolean>{
    const apiPath = '/api/user/loginWithPassword';

    const data = {
      username: username,
      password:  password,
      apply_id: apply_id,
      verify_code: verify_code,
      ui: SystemUserInterfaceEnums.BACKEND
    };

    const response = await apiHelper.post<UserTokenDocument>(apiPath, data);

    // 存储令牌
    localStorage.setItem('OnlineBusinessHall.Token', response.token);
    localStorage.setItem('OnlineBusinessHall.userId', response.userId);

    return true;
  }

  static async modifyPassword(old_password:string, new_password:string) : Promise<void> {
    const apiPath = '/api/user/updatePassword';
    const data = {
      old_password: old_password,
      new_password: new_password
    };
    await apiHelper.post<UserTokenDocument>(apiPath, data);
  }

  static async logout() : Promise<boolean> {
    const token = localStorage.getItem('OnlineBusinessHall.Token');
    if (token) {
      const apiPath = '/api/user/logout';

      const data = {
        token: token
      };
      await apiHelper.post<UserTokenDocument>(apiPath, data);
    }

    localStorage.removeItem('OnlineBusinessHall.Token');
    localStorage.removeItem('OnlineBusinessHall.userId');

    return true;
  }
}